import IFiltersIndicatorsPanel, { IGroupersIndicators, IGroupersIndicatorsSelect, IndicatorShowValues } from "../interface";

export interface IGrouperOfIndicators{
    grouper: IGroupersIndicators;
    groupersSelect: IGroupersIndicatorsSelect;
    filters: IFiltersIndicatorsPanel;
    showValues: IndicatorShowValues;
    layoutList: "list" | "card";
    expandedProp?: boolean;
    onCallbackChangeValuesIndicator?: (reset: boolean) => void;
    recursiveProps?: {
        onCallbackUpdateParent: (newLevel: IIndicatorsLevel, oldLevel: IIndicatorsLevel, updatedGrouperData?: IGroupersIndicators) => void;
        onCallbackDeleteParent: (deletedLevel: IIndicatorsLevel, updatedGrouperData?: IGroupersIndicators) => void;
        initialFilterList?: IIndicatorsLevel;
        checkAll: boolean;
    }
}

export interface IGroupersIndicatorsList{
    grouperId: number; 
    grouperId2?: number | null; 
    grouperId3?: number | null; 
    grouperId4?: number | null;
}

export interface IListOfIndicators{
    groupers: IGroupersIndicatorsList;
    groupersSelect: IGroupersIndicatorsSelect;
    showValues: IndicatorShowValues;
    layoutList: "list" | "card";
    
    filters?: IFiltersIndicatorsPanel;
    filterList?: IIndicatorsLevel;

    onCallbackDelete?: Function;
    onCallbackUpdate?:Function;

    onCallbackChangeValuesIndicator?: Function;

    defaultChecked: boolean;
}

export interface IIndicatorsValues{
    goal: number;
    percentage: number;
    value: number;
    label: string;
    labelCode: string;
    labelCompareGoal: string;
    labelGoal: string;
    hasFca: boolean;
    fcaAbsent: boolean;
    color: string | null;
    hasValue: boolean;
    decimalPlaces: number;
    currentPeriod: string | null;
    periodId?: number | null;
    isDisabled?: boolean;
}

export enum IIndicatorsLevel {
    OPERATIONAL="O",
    TACTIC = "T",
    STRATEGIC = "E"
}

export interface IMetricRanges{
    color: string;
	start: number;
	end: number;
}

export interface IIndicatorsMetrics{
    maxValue: number;
    metricRanges: IMetricRanges[];
}

export interface IListIndicators {
    iqc001Id: number;
    iqc001Nivel: IIndicatorsLevel;
    iqc001Formaaval: number;
    iqc001Descricao: string;
    iqc001Linkexterno: string;
    iqc001LDecimaispainel: number;
    iqb003Descricao: string;
    iqc001Mostrarvalor: number;
    values: IIndicatorsValues[];
    accumulatedValues: IIndicatorsValues[];
    metrics: IIndicatorsMetrics;
    hasChildren: boolean;
    permission: number;
    children?: IListIndicators[];
}
